.root {
  display: block;
}

.svg {
  display: block;
  overflow: visible;
}

.rotated {
  transform: rotate(-90deg);
  transform-origin: 50% 50%;
}

.track {
  fill: none;
  stroke: var(--color-muted);
}

.progress {
  fill: none;
  stroke: currentColor;
  transition: stroke-dashoffset 200ms ease;
}

.tone_positive {
  color: #079100;
}

.tone_negative {
  color: #d80d0d;
}

.tone_mediocre {
  color: #d8b60d;
}

.tone_unknown {
  color: #777;
}

.isAnimating {
  animation: pulse 1s infinite alternate;
}

@keyframes pulse {
  from {
    opacity: 1;
  }

  to {
    opacity: 0.6;
  }
}
